import { INIT_NEW_HABIT } from 'assets/data';
import Warning from 'assets/icons/Warning';
import Tooltip from 'components/common/Tooltip';
import { PRIORITY_OPTION } from 'constants/general';
import { t } from 'services/i18n.service';
import { useState } from 'react';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { newActivityButtonSelector } from 'store/reducer/setting/selectors';
import { newHabit } from 'store/reducer/setting/slice';
import { getNewHabitProps } from 'utils/helpers';
import COLOR from 'constants/color';
import { diffInSeconds } from 'utils/time.util';
import { ATTRIB } from 'constants/test';
import CloseCircle from 'assets/icons/CloseCircle';
import { BaseButtonXs } from 'components/ui/BaseButton';

const AddFreeTimeHabitButton = () => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const dispatch = useAppDispatch();
  const {
    activeTabIndex,
    tabs,
    currentSettings,
    customRoutine,
    userFocusModes
  } = useAppSelectorShallow(newActivityButtonSelector);

  const handleClick = () => {
    const {
      shutdown_time,
      cutoff_time_for_non_high_priority_activities: cutoff_time
    } = currentSettings;
    const duration_seconds = diffInSeconds(cutoff_time, shutdown_time);

    const [activity_type, sequence_id] = getNewHabitProps(
      tabs,
      activeTabIndex,
      currentSettings,
      customRoutine
    );

    const allowed_focus_mode_id = userFocusModes?.find(
      (focus_mode) =>
        focus_mode.name.includes('Relax') || focus_mode?.metadata?.isRelaxFocus
    )?.id;

    const freeTimeHabit = {
      ...INIT_NEW_HABIT(),
      name: t('free_time_no_distraction_blocking'),
      duration_seconds,
      allowed_focus_mode_id,
      show_saved_distracting_websites: true,
      priority: PRIORITY_OPTION.STANDARD
    };
    dispatch(
      newHabit({
        type: activity_type,
        sequence_id,
        isFreeTimeHabit: true,
        freeTimeHabit
      })
    );
  };

  return (
    <div
      className={`${!isBannerVisible && 'hidden'} relative ~mt-1/2 w-fit ~-mb-4/8`}>
      <div className='min-w-max flex items-center rounded-lg ~px-3/4 ~py-1.5/3 ~gap-4/5 shadow-md ~text-xs/sm bg-primary-50 dark:bg-secondary-dark-300 dark:border dark:border-secondary-dark-500'>
        <div className='flex items-center'>
          <Warning styles='~w-3/5 ~h-3/5 inline-flex align-middle ~mr-1/2' />
          <p className='min-w-max font-medium ~text-[0.65rem]/sm text-black dark:text-secondary-dark-900'>
            {t('free_time_habit_not_set')}
            <Tooltip
              message={t('relax_mode_habit_duration_tooltip')}
              iconStyles='~w-3/4 ~h-3/4'
            />
          </p>
        </div>
        <BaseButtonXs
          onClick={handleClick}
          additionalStyles='~px-2/3 min-w-max capitalize'
          data-testid={ATTRIB.DATA_TESTID.CREATE_FREE_TIME_HABIT_BTN}
          title={t('create_one')}
        />
      </div>
      <BaseButtonXs
        onClick={() => setIsBannerVisible(false)}
        additionalStyles='~px-1/2 absolute -top-2 ~-right-2/4 !bg-transparent !border-none !shadow-none'
        icon={
          <CloseCircle
            styles='~w-3.5/5 h-auto'
            fill={COLOR.PRIMARY.LIGHT_900}
          />
        }
        variant='icon'
        aria-label={t('close')}
      />
    </div>
  );
};

export default AddFreeTimeHabitButton;
